<template functional>
  <div>
    <!-- <el-input-number
      size="mini"
      v-model="data.attrs.rowValue"
      :precision="0"
      :step="1"
      :controls="false"
      controls-position="right"
      :min="0"
      :max="
        data.attrs.row.TypeOfTime === 'h'
          ? 8
          : data.attrs.row.TypeOfTime === 'm'
          ? 480
          : 0
      "
      @blur="($event) => $options.UpdatingValueDb($event, data)"
      @change="
        ($event) =>
          $options.UpdatingValue(
            $event,
            data
          ) /* data.attrs.rowValue = parseFloat($event.target.value)*/
      "
    >
    </el-input-number> -->
    <el-select
      v-model="data.attrs.rowValue"
      size="mini"
      placeholder="Tiempo"
      @change="($event) => $options.UpdatingValueDb($event, data)"
    >
      <el-option
        v-for="item in $options.options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  name: "TimeSelector",

  options: [
    { value: 0.5, label: "0.5" },
    { value: 1, label: "1" },
    { value: 1.5, label: "1.5" },
    { value: 2, label: "2" },
    { value: 2.5, label: "2.5" },
    { value: 3, label: "3" },
    { value: 3.5, label: "3.5" },
    { value: 4, label: "4" },
    { value: 4.5, label: "4.5" },
    { value: 5, label: "5" },
    { value: 5.5, label: "5.5" },
    { value: 6, label: "6" },
    { value: 6.5, label: "6.5" },
    { value: 7, label: "7" }
  ],
  UpdatingValue(event, data) {
    let value =
      typeof event === "number" ? event : parseInt(event.target.value);
    //data.attrs.rowValue = value;
    data.attrs.row[data.attrs.column] = value;

    data.attrs.updatingTimeOntaskValue(data.attrs.row);
  },
  UpdatingValueDb(event, data) {
    let value =
      typeof event === "number" ? event : parseInt(event.target.value);
    data.attrs.row[data.attrs.column] = value;
    data.attrs.updatingTimeOntaskValue(data.attrs.row);
  }
};
</script>
